import { getIndexName } from '../../util/algolia.js';
import { CategoriesResultTaxonomy } from '../taxonomy/Taxonomies.js';
import { AlgoliaIndexResultPlugin, getSearchParametersBuilder } from './AlgoliaPlugin.js';
import 'fuse.js';
import { FlyoutDiscoveryProductResultsPlugin } from './FlyoutDiscoveryResultPlugins.js';

var getFlyoutSearchParametersBuilder = function getFlyoutSearchParametersBuilder(locale) {
  return function (userAbTests) {
    var userSearchParameters = getSearchParametersBuilder()(userAbTests);
    userSearchParameters.attributesToRetrieve = ['objectID', 'title', 'description', 'showInAbTests', 'hideInAbTests', 'landingUrl', 'imageUrl', 'inStock'];
    userSearchParameters.attributesToHighlight = ['title', 'description'];
    return userSearchParameters;
  };
};
var FlyoutCategoriesResultsPlugin = function FlyoutCategoriesResultsPlugin(locale, hitsPerPage) {
  var taxonomyId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : CategoriesResultTaxonomy.id;
  var indexName = getIndexName('vistaprint', 'prod', locale, 'categories');
  return AlgoliaIndexResultPlugin(indexName, indexName, taxonomyId, getFlyoutSearchParametersBuilder(), hitsPerPage, 'categories', true);
};
var FlyoutDefaultResultPlugins = function FlyoutDefaultResultPlugins(locale) {
  var hitsPerPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
  var queryCategorizationExperiment = arguments.length > 2 ? arguments[2] : undefined;
  return [FlyoutDiscoveryProductResultsPlugin(locale, hitsPerPage, queryCategorizationExperiment), FlyoutCategoriesResultsPlugin(locale, hitsPerPage)];
};

export { FlyoutCategoriesResultsPlugin, FlyoutDefaultResultPlugins };
//# sourceMappingURL=FlyoutResultPlugins.js.map
